import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAppConfig } from '../redux/appConfigReducer';

const useCtaURLBuilder = () => {
  const { marketType } = useSelector(selectAppConfig);
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;

  const isTestCAPage = window.location.hostname.startsWith('pre-');
  const isTestUSPage = window.location.hostname.startsWith('qa');

  const isOldTestCAPage =
    window.location.hostname === 'www.audi.ca' && window.location.pathname.includes('test_pages');
  const isOldTestUSPage =
    window.location.hostname === 'www.audiusa.com' &&
    window.location.pathname.includes('test_pages');

  const isLocalHost = window.location.host.includes('localhost');

  const isUSProd =
    window.location.hostname === 'www.audiusa.com' &&
    !window.location.pathname.includes('test_pages');
  const isCAProd =
    window.location.hostname === 'www.audi.ca' && !window.location.pathname.includes('test_pages');

  if (isTestCAPage) return `https://pre-www.audi.ca/${lang}/inventory/vehicle/`;
  if (isTestUSPage) return `https://qa.audiusa.com/en/inventory/vehicle/`;

  if (isOldTestCAPage) return `https://pre-www.audi.ca/${lang}/inventory/vehicle/`;
  if (isOldTestUSPage) return `https://qa.audiusa.com/en/inventory/vehicle/`;

  if (isCAProd) return `https://www.audi.ca/${lang}/inventory/vehicle/`;
  if (isUSProd) return `https://www.audiusa.com/en/inventory/vehicle/`;

  if (isLocalHost)
    return marketType === 'CAN'
      ? `https://www.audi.ca/${lang}/inventory/vehicle/`
      : `https://www.audiusa.com/en/inventory/vehicle/`;

  // For Tier 3 pages,
  const url = window.location.href;
  const inventoryIndex = url.indexOf('inventory');
  const finalHostUrl = url.substring(0, inventoryIndex);

  return `${finalHostUrl}inventory/vehicle/`;
};

export default useCtaURLBuilder;
